import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { BreadcrumbComponent } from '@app/components/breadcrumb/breadcrumb.component';
import { NavbarVerticalComponent } from '@app/components/navbar/navbar-vertical/navbar-vertical.component';
import { TranslateModule } from '@ngx-translate/core';
import { ProjectsStore } from '../+store/projects/projects.store';
import { ComponentsModule } from '../components/components.module';
import { AdminLayoutComponent } from './admin-layout/admin-layout.component';
import { LayoutsRoutingModule } from './layouts-routing.module';
import { MainLayoutComponent } from './main-layout/main-layout.component';

@NgModule({
  declarations: [MainLayoutComponent, AdminLayoutComponent],
  imports: [
    CommonModule,
    LayoutsRoutingModule,
    ComponentsModule,
    TranslateModule,
    NavbarVerticalComponent,
    BreadcrumbComponent,
  ],
  providers: [ProjectsStore],
  exports: [MainLayoutComponent, AdminLayoutComponent],
})
export class LayoutsModule {}
